import {Positions} from '@/utils/positionEnum';

// Predikáty vytažené ze Stepper.vue pro nový skelet (newUi).
// Chování 1:1 se starým Stepperem - včetně zvláštností (WILD_OBSTACLE new day
// povoluje, LEAGUE_REGISTER není ve skrývacím výčtu). Stavy viz
// claude/architecture/position-state-machine/. Duplicita se Stepperem je
// dočasná, zmizí se smazáním starého skeletu.

const NEW_DAY_BLOCKED = [
    Positions.FIGHT,
    Positions.DUNGEON,
    Positions.DUNGEON_CHALLENGE,
    Positions.FIGHT_TRAINER,
    Positions.MEWTWO_FIGHT,
    Positions.FIGHT_TEAM_ROCKET,
];

const STEPPER_HIDDEN = [
    Positions.FIGHT_STADION_TRAINER_WIN,
    Positions.START,
    Positions.LEAGUE_FIGHT,
    Positions.LEAGUE_LOSE,
    Positions.LEAGUE_WIN,
    Positions.LEAGUE_OAK,
    Positions.MEWTWO_FIGHT_WIN,
];

export function canNewDay(position) {
    return !!position && !NEW_DAY_BLOCKED.includes(position.type);
}

export function cantNewDay(position) {
    return !!position && NEW_DAY_BLOCKED.includes(position.type);
}

export function stepperVisible(position, routeName) {
    return !!position && !STEPPER_HIDDEN.includes(position.type) && routeName === 'Journey';
}
